import React from 'react';
import { Redirect } from 'react-router-dom';
import { LoadingIndicator } from 'components/common/LoadingIndicator';
import {
  DefaultL1ObjectManager,
  L1ObjectManager
} from 'core/l1Object/L1ObjectManager';

const defaultL1ObjectManager: L1ObjectManager = new DefaultL1ObjectManager();
export class CampaignRedirect extends React.PureComponent<
  {
    l1ObjectId: string | number;
    campaignId: string | number;
    action?: string;
    l1ObjectManager?: L1ObjectManager;
  },
  { redirectPath: string | undefined }
> {
  constructor(props) {
    super(props);
    this.state = {
      redirectPath: undefined
    };
  }

  componentDidMount() {
    this.getParentInfo();
  }

  async getParentInfo() {
    const l1ObjectManager = this.props.l1ObjectManager
      ? this.props.l1ObjectManager
      : defaultL1ObjectManager;
    try {
      const orderNumber = await l1ObjectManager.getOrderNumber(
        this.props.l1ObjectId
      );
      const redirectPath = this.props.action
        ? `/orders/${orderNumber}/campaign-groups/${this.props.l1ObjectId}/campaigns/${this.props.campaignId}/${this.props.action}`
        : `/orders/${orderNumber}/campaign-groups/${this.props.l1ObjectId}?search=${this.props.campaignId}`;
      this.setState({
        redirectPath
      });
    } catch (e) {
      this.setState({
        redirectPath: '/'
      });
    }
  }

  render() {
    if (this.state.redirectPath) {
      return <Redirect to={this.state.redirectPath} />;
    }
    return <LoadingIndicator />;
  }
}
